import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class RoadKillGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_NUMBERS_MULTIPLIER = "NumbersMultiplier";
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(RoadKillGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(RoadKillGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(RoadKillGameAssets.BITMAP_FONT_NUMBERS_MULTIPLIER, "fonts/bitmapfonts/NumbersMultiplier.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json"),
                    new TextureAsset("backgroundsJpeg4", "sheets/backgroundsJpeg/backgroundsJpeg4.json"),

                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("S1", "spine/s.json"),
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("M5", "spine/M5.json"),
                    new SpineAsset("L1", "spine/L1.json"),
                    new SpineAsset("L2", "spine/L2.json"),
                    new SpineAsset("L3", "spine/L3.json"),
                    new SpineAsset("L4", "spine/L4.json"),
                    new SpineAsset("L5", "spine/L5.json"),
                    new SpineAsset("M1_split", "spine/M1_split.json"),
                    new SpineAsset("M2_split", "spine/M2_split.json"),
                    new SpineAsset("M3_split", "spine/M3_split.json"),
                    new SpineAsset("M4_split", "spine/M4_split.json"),
                    new SpineAsset("M5_split", "spine/M5_split.json"),
                    new SpineAsset("L1_split", "spine/L1_split.json"),
                    new SpineAsset("L2_split", "spine/L2_split.json"),
                    new SpineAsset("L3_split", "spine/L3_split.json"),
                    new SpineAsset("L4_split", "spine/L4_split.json"),
                    new SpineAsset("L5_split", "spine/L5_split.json"),
                    new SpineAsset("SW1", "spine/SW_1.json"),
                    new SpineAsset("SW2", "spine/SW_2.json"),
                    new SpineAsset("SW3", "spine/SW_3.json"),
                    new SpineAsset("heart", "spine/heart.json"),
                    new SpineAsset("rabbitHead", "spine/rabbitHead.json"),
                    new SpineAsset("deerHead", "spine/deerHead.json"),
                    new SpineAsset("bearHead", "spine/bearHead.json"),
                    new SpineAsset("bg", "spine/bg.json"),
                    new SpineAsset("split", "spine/split.json"),
                    new SpineAsset("fsIntro", "spine/fsIntro.json"),
                    new SpineAsset("sfsIntro", "spine/sfsIntro.json"),
                    new SpineAsset("fsOutro", "spine/fsOutro.json"),
                    new SpineAsset("sfsOutro", "spine/sfsOutro.json"),
                    new SpineAsset("carHilly", "spine/car1.json"),
                    new SpineAsset("carBilly", "spine/car2.json"),
                    new SpineAsset("bigWin", "spine/bigWin.json"),
                    new SpineAsset("wildOverlay", "spine/wild.json"),
                    new SpineAsset("animalCollectionHeads", "spine/superCollect.json"),
                    new SpineAsset("bearCount", "spine/bearCount.json"),
                    new SpineAsset("deerCount", "spine/deerCount.json"),
                    new SpineAsset("rabbitCount", "spine/rabbitCount.json"),
                    new SpineAsset("roadblock", "spine/road_block.json"),
                    new SpineAsset("winCap", "spine/Win_Cap.json"),
                    new SpineAsset("respin", "spine/skeleton.json"),
                    new SpineAsset("heartBase", "spine/heartBG.json"),
                ]
            },
            {
                name: "main",
                assets: this.getMainArr(),
                animations: {
                    "bgFrame": "ui/reelDividers/div",
                    "gameLogo": "introLogo",
                    "winAmountExplosion": "winFx/winAmountExplosion/winBoom_",
                    "reelExcitement": "winFx/spinExcitement/excitement_",
                    "x2": "winFx/x2",
                    "rabbitSmoke": "winFx/rabbit_smoke/rabbit_smoke_",
                    "billyBubble": "car/billyBubble",
                    "hillyBubble": "car/hillyBubble",
                    "tyreBubbles": "car/tire",
                    "behindMulti": "winFx/multiplierFx/multifx_"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    // new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json")
                ],
                animations: {
                    "glow": "wGlow/tinyWinBlink",
                    "kingOfTheRoad": "bigWin/parts/winCapText"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {
                    "SW1MassiveWin": "SW1/SW1_cover",
                    "SW2MassiveWin": "SW2/SW2_cover",
                    "SW3MassiveWin": "SW3/SW3_cover",
                    "SWMassiveWinFullCover": "SW3x3/SW3x3",
                    "SW1Golden": "SW1/SW1_lvl5",
                    "SW2Golden": "SW2/SW2_lvl5",
                    "SW3Golden": "SW3/SW3_lvl5",
                    "greenTrapCar": "SW3/SW3trap",
                    "redTrapCar": "SW3/SW3trap_2",
                    "greenTrapCarSplit": "SW3/SW3trap_split",
                    "redTrapCarSplit": "SW3/SW3trap2_split",
                    "Cone_Particle": "BW_Particles/Cone_SEQ/Cone_",
                    "Wheel_Particle": "BW_Particles/Wheel_SEQ/Wheel_",
                    "Wunder_Particle": "BW_Particles/Wunder_SEQ/Wunder_",
                }
            }
        ]
    };

    public static getMainArr(): TextureAsset[] {
        const mainSheetArr: TextureAsset[] = [];
        for (let sheetIndex = 0; sheetIndex <= 7; sheetIndex++) {
            mainSheetArr.push(new TextureAsset("main" + sheetIndex, "sheets/main/main" + sheetIndex + ".json"));
        }
        return mainSheetArr;
    }

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }
}